import {
  Backdrop,
  Box,
  Button,
  Fade,
  Grid,
  MenuItem,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import ComponentBackdrop from "../../components/backdrop";

import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom";
import { useApiClient } from "../../context/ApiClientContext";
import api from "../../helper/baseApi";
import SuccessAlert from "../../helper/successAlert";
import ErrorAlert from "../../helper/errorAlert";
import EditUserModal from "./editUserModal";
import ViewUser from "./viewUser";

const DetailsUserForm = ({ mode, userDetails, onModeChange, onSuccess, refetch }) => {
  const labelWidth = 130;
  const { id } = useParams();
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputForm, setInputForm] = useState({
    code: "",
    name: "",
    email: "",
    roleId: "",
    gender: "",
    dob: "",
    designationId: "",
    departmentId: "",
    jobGradeId: "",
    reportsToId: "",
  });
  const [roleList, setRoleList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [designationList, setDesignationList] = useState([]);
  const [jobGradeList, setJobGradeList] = useState([]);
  const [reportToList, setReportToList] = useState([]);
  const [remark, setRemark] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [openUserModal, setOpenUserModal] = useState(false);
  const { apiUrls: { mobileApiUrl } } = useApiClient();

  const navigate = useNavigate();

  useEffect(() => {
    if (mode === "edit" || mode === "view") {
      console.log('userDetails', userDetails);
      
      setInputForm(userDetails || {}); // preload with userDetails
    }
  }, [mode, userDetails]);

  useEffect(() => {
    fetchOptionLists();
    fetchOptionUser();
  }, []);

  const fetchOptionLists = async () => {
    try {
      setOpenBackdrop(true);
      // Fetch roles
      let response = await api.get(`${mobileApiUrl}user/user-optional`);

      setRoleList(response.data.data.roles || []);
      // Set departments
      setDepartmentList(response.data.data.departments || []);
      // Set designations
      setDesignationList(response.data.data.designations || []);
      // Set job grades
      setJobGradeList(response.data.data.jobGrades || []);
      // setReportToList(response.data.data.reportTos || []);
      setOpenBackdrop(false);
    } catch (error) {
      ErrorAlert(error, navigate);
      setOpenBackdrop(false);
    }
  };

  const fetchOptionUser = async () => {
    try {
      setOpenBackdrop(true);
      // Fetch roles
      let response = await api.get(`${mobileApiUrl}user/user-employee-list`);
      // Set report to
      setReportToList(response.data.data.userEmployeeList || []);
      
      setOpenBackdrop(false);
    } catch (error) {
      ErrorAlert(error, navigate);
      setOpenBackdrop(false);
    }
  };

  const handleInputChange = (property, event) => {
    const value = event.target.value;
    console.log('value', value);
    
    setInputForm((prevState) => ({
      ...prevState,
      [property]: value,
    }));
  };

  const SubmitButton = () => (
    <Box mr={2}>
      <Button
        fullWidth
        variant="contained"
        size="medium"
        onClick={() => submitForm()}
        sx={{
          backgroundColor: "secondary.main",
          fontWeight: "600",
          "&:hover": { backgroundColor: "secondary.dark" },
          //   mb: 3,
        }}
      >
        Save
      </Button>
    </Box>
  );

  const EditButton = () => (
    <Box width="15%">
      <Button
        fullWidth
        variant="contained"
        size="medium"
        onClick={handleOpenUserModal}
        sx={{
          backgroundColor: "secondary.main",
          fontWeight: "600",
          "&:hover": { backgroundColor: "secondary.dark" },
        }}
      >
        Edit
      </Button>
    </Box>
  );

  const updateForm = () => {
    setOpenBackdrop(true);

    const timer = setTimeout(() => {
      setOpenBackdrop(false);
      toast.success("User is updated"); // ✅ show after backdrop closes
    }, 3000);

    onModeChange("view");
  };

  const submitForm = async (forceMode) => {
    const currentMode = forceMode || mode; // ✅ allow modal to override
    let newErrors = {};

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      setOpenBackdrop(true);

      let response = '';
      let apiUrl = '';

      if (currentMode === 'edit') {
        const employeeId = id;
        const payload = {
          employeeId: employeeId,
          code: inputForm.code,
          name: inputForm.name,          // map 'name' -> 'fullName'
          roleId: inputForm.roleId,
          gender: inputForm.gender,
          dob: inputForm.dob,        // map 'dob' -> 'dateOfBirth'
          designationId: inputForm.designationId,
          departmentId: inputForm.departmentId,
          jobGradeId: inputForm.jobGradeId,
          reportsToId: inputForm.reportsToId || null, // optional if not in form 
        };

        console.log('payload', payload);
        
        apiUrl = `${mobileApiUrl}user/update-user-employee`;
        response = await api.put(apiUrl, payload);
      } else {
        const payload = {
          email: inputForm.email,
          code: inputForm.code,
          gender: inputForm.gender,
          dateOfBirth: inputForm.dob,        // map 'dob' -> 'dateOfBirth'
          fullName: inputForm.name,          // map 'name' -> 'fullName'
          designationId: inputForm.designationId,
          departmentId: inputForm.departmentId,
          jobGradeId: inputForm.jobGradeId,
          reportsToId: inputForm.reportsToId || null, // optional if not in form
          roleId: inputForm.roleId,
        };

        apiUrl = `${mobileApiUrl}user/add-poisum-user`;
        response = await api.post(apiUrl, payload);
      }

      if (response.status == 200) {
        setTimeout(() => {
          if (mode == 'create') {
            onModeChange(false);
            onSuccess?.();
          } else {
            onModeChange("view");
            // navigate("/user");
            refetch();
          }
          setOpenBackdrop(false);
          SuccessAlert(response.data.message);
        }, 2000);
      }
    } catch (error) {
      ErrorAlert(error, navigate);
      setOpenBackdrop(false);
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setRemark("");
  };

  const handleOpenUserModal = () => {
    setOpenUserModal(true);
  };
  const handleCloseUserModal = () => {
    setOpenUserModal(false);
  };

  const onSuspend = async () => {
    try {
      setOpenBackdrop(true);
      setOpenModal(false);
      let response = await api.post(`${mobileApiUrl}user/suspend`);

      if (response.status === 200) {
        toast.success("Event suspended successfully");
        navigate("/event"); // Navigate to event listing page
      }
    } catch (error) {
      ErrorAlert(error, navigate);
    } finally {
      setOpenBackdrop(false);
    }
  };

  // const formatDateForInput = (dateStr) => {
  //   if (!dateStr) return "";
  //   const parsed = dayjs(dateStr, ["DD/MM/YYYY", "YYYY-MM-DD", "D/M/YYYY"], true);
  //   return parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
  // };

  const formatDateForInput = (dateStr) => {
    if (!dateStr) return "";

    // Try to parse multiple possible formats including ISO strings
    const parsed = dayjs(dateStr, [
      "DD/MM/YYYY",
      "YYYY-MM-DD",
      "D/M/YYYY",
      dayjs.ISO_8601
    ]);

    return parsed.isValid() ? parsed.format("YYYY-MM-DD") : "";
  };

  const renderField = (
    label,
    id,
    type = "text",
    select = false,
    options = [],
    disabled = false
  ) => {
    const getDisplayValue = () => {
      const value = inputForm[id];
      if (!value) return "-";
      if (type === "date") return formatDateForInput(value);
      if (select && options.length > 0) {
        const found = options.find((opt) => opt.value === value);
        return found ? found.label : value;
      }
      return value;
    };

    if (disabled || mode === "view") {
      // 🔹 View mode → Use Typography field
      return (
        <ViewUser
          label={label}
          value={getDisplayValue()}
          labelWidth={labelWidth}
        />
      );
    }

    // 🔹 Create/Edit mode → Use input field
    return (
      <Box>
        <Typography sx={{ fontWeight: 500, mb: 0.5 }}>{label}</Typography>
        <TextField
          id={id}
          type={type}
          select={select}
          value={
            type === "date"
              ? formatDateForInput(inputForm[id])
              : inputForm[id] || ""
          }
          onChange={(e) => handleInputChange(id, e)}
          fullWidth
          size="small"
          variant="outlined"
        >
          {select &&
            options.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
        </TextField>
      </Box>
    );
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          
        }}
      >
        <Box width="100%" display="flex" justifyContent="flex-end" sx={{ pt: 2, px:1, mb: { xs: 2} }}>
          <Typography variant="subtitle" sx={{ flexGrow: 1, fontWeight: "600", textTransform: 'uppercase' }}>
            {mode === "create" ? "Create New User" : "Personal Info"}
          </Typography>
          {mode === "create" ? (
            <SubmitButton />
          ) : (
            <EditButton />
          )}{" "}
          {/* <Button
          variant="contained"
          size="medium"
          onClick={handleOpenUserModal}
          sx={{
            ml: 2,
            backgroundColor: "secondary.main",
            fontWeight: "600",
            "&:hover": { backgroundColor: "secondary.dark" },
            //   mb: 3,
          }}
        >
          Set Inactive
        </Button> */}
        </Box>

        {mode === "view" ? (
          // 🟩 VIEW MODE — stacked layout using <ViewUser>
          <Grid container>
          <Grid size={6} px={2}>
            {renderField("Employee Code", "code", "text", false, [], true)}
            {renderField("Full Name", "name", "text", false, [], true)}
            {renderField(
              "Assign Role",
              "roleId",
              "text",
              true,
              roleList.map((r) => ({ value: r.roleId, label: r.roleName })),
              true
            )}
            {renderField("Email", "email", "email", false, [], true)}
             {renderField(
              "Gender",
              "gender",
              "text",
              true,
              [
                { value: "male", label: "Male" },
                { value: "female", label: "Female" },
              ],
              true
            )}
            </Grid>
          <Grid size={6} px={2}>
           
            {renderField("Date Of Birth", "dob", "date", false, [], true)}
            {renderField(
              "Department",
              "departmentId",
              "text",
              true,
              departmentList.map((d) => ({
                value: d.departmentId,
                label: d.name,
              })),
              true
            )}
            {renderField(
              "Designation",
              "designationId",
              "text",
              true,
              designationList.map((d) => ({
                value: d.designationId,
                label: d.name,
              })),
              true
            )}
            {renderField(
              "Job Grade",
              "jobGradeId",
              "text",
              true,
              jobGradeList.map((d) => ({
                value: d.jobGradeId,
                label: d.name,
              })),
              true
            )}
            {renderField(
              "Report To",
              "reportsToName",
              "text",
              false,
              // reportToList.map((r) => ({
              //   value: r.employeeId,
              //   label: r.name,
              // })),
              true
            )}
            </Grid>
            </Grid>
        ) : (
          // 🟦 CREATE/EDIT MODE — 2-column grid layout
          <Grid container spacing={2}>
            {[
              renderField("Employee Code", "code"),
              renderField("Full Name", "name"),
              renderField(
                "Assign Role",
                "roleId",
                "text",
                true,
                roleList.map((r) => ({ value: r.roleId, label: r.roleName }))
              ),
              renderField("Email", "email", "email"),
              renderField(
                "Gender",
                "gender",
                "text",
                true,
                [
                  { value: "male", label: "Male" },
                  { value: "female", label: "Female" },
                ]
              ),
              renderField("Date Of Birth", "dob", "date"),
              renderField(
                "Department",
                "departmentId",
                "text",
                true,
                departmentList.map((d) => ({
                  value: d.departmentId,
                  label: d.name,
                }))
              ),
              renderField(
                "Designation",
                "designationId",
                "text",
                true,
                designationList.map((d) => ({
                  value: d.designationId,
                  label: d.name,
                }))
              ),
              renderField(
                "Job Grade",
                "jobGradeId",
                "text",
                true,
                jobGradeList.map((d) => ({
                  value: d.jobGradeId,
                  label: d.name,
                }))
              ),
              renderField(
                "Report To",
                "reportsToId",
                "text",
                true,
                reportToList.map((r) => ({
                  value: r.employeeId,
                  label: r.name,
                }))
              ),
            ].map((field, index) => (
              <Grid item key={index} size={6}>
                {field}
              </Grid>
            ))}
          </Grid>
        )}

        <ComponentBackdrop openBackdrop={openBackdrop} />

        {/* ✅ Remark Modal */}
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{ backdrop: { timeout: 500 } }}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Fade in={openModal} timeout={500}>
            <Box
              sx={{
                bgcolor: "background.paper",
                boxShadow: 24,
                px: 3,
                pb: 3,
                borderRadius: 2,
                overflowY: "auto",
                position: "relative",
                width: { xs: "90%", sm: "70%", md: "40%" },
                maxHeight: "90vh",
              }}
            >
              <Typography
                variant="subtitle"
                sx={{
                  mt: 3,
                  mb: 2,
                  fontWeight: 600,
                  textTransform: "uppercase",
                }}
              >
                Set Inactive
              </Typography>

              <TextField
                fullWidth
                label="Remark"
                multiline
                minRows={3}
                variant="outlined"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                sx={{ mb: 3 }}
              />

              <Box display="flex" justifyContent="flex-end" gap={2}>
                <Button
                  variant="outlined"
                  color="inherit"
                  onClick={handleCloseModal}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={onSuspend}
                  disabled={!remark.trim()}
                >
                  Confirm
                </Button>
              </Box>
            </Box>
          </Fade>
        </Modal>

        {/* ✅ Edit Modal */}
        <EditUserModal
          open={openUserModal}
          onClose={handleCloseUserModal}
          inputForm={inputForm}
          setInputForm={setInputForm}
          handleInputChange={handleInputChange}
          roleList={roleList}
          departmentList={departmentList}
          designationList={designationList}
          jobGradeList={jobGradeList}
          reportToList={reportToList}
          onSubmit={submitForm}
          mode="edit"
        />

      </Box>
    </>
  );
};

export default DetailsUserForm;
